var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NcButton',{staticClass:"memories-menu-item upload-menu",attrs:{"title":_vm.t('memories', 'Upload'),"aria-label":_vm.t('memories', 'Upload')},on:{"click":_vm.upload},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('UploadIcon',{attrs:{"size":20}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }